var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconDietScale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29 7.84a.76.76 0 0 0 .71.41h8a.76.76 0 0 0 .67-.41l1-1.92a.76.76 0 0 0-.36-1A13.18 13.18 0 0 0 12 3.75 13.18 13.18 0 0 0 6.69 4.9a.76.76 0 0 0-.36 1Zm3.21 5.29c0-1-1.18-1.88-2.63-1.88s-2.62.84-2.62 1.88v5.25a1.88 1.88 0 0 0 3.75 0 7.45 7.45 0 0 1 1.29-4.52 1.47 1.47 0 0 0 .21-.73Zm3 0c0-1 1.18-1.88 2.62-1.88s2.63.84 2.63 1.88v5.25a1.88 1.88 0 0 1-3.75 0 7.45 7.45 0 0 0-1.29-4.52 1.47 1.47 0 0 1-.21-.73ZM9.75 3.95v1.3m4.5-1.3v1.3",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconDietScale);
export default __webpack_public_path__ + "static/media/streamline-icon-diet-scale.52be6d9e.svg";
export { ForwardRef as ReactComponent };